module.exports = __webpack_public_path__ + "img/home-3.b83aa614.png";